/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

// import './echo';

import {annotate} from 'rough-notation';
import mitt from 'mitt';

const emitter = mitt();

window.app.emit = (eventName, payload = {}) => {
    emitter.emit(eventName, payload);
};

window.app.on = (eventName, handler = null) => {
    emitter.on(eventName, handler);
};

window.app.off = (eventName, handler = null) => {
    emitter.off(eventName, handler);
};

window.app.snackbar = (config = {}) => {
    window.app.emit('snackbar', config);
};

window.addEventListener('load', () => {

    const options = {
        root: null,
        rootMargin: '15px 0px', // Smaller buffer to give a bit of space
        threshold: 0.5, // Require 50% of the element to be visible
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // Only run the annotation when the element is in the viewport
                const element = entry.target;

                setTimeout(() => {
                    let annotation;

                    if (element.classList.contains('underline-hand')) {
                        annotation = annotate(element, {
                            color: '#a74bff',
                            padding: 0,
                            type: 'underline',
                        });
                    } else if (element.classList.contains('highlight-hand')) {
                        annotation = annotate(element, {
                            color: 'rgba(255,247,59,0.6)',
                            padding: 0,
                            type: 'highlight',
                        });
                    }

                    if (annotation) {
                        annotation.show();
                    }

                    // Stop observing after the annotation is applied
                    observer.unobserve(element);
                }, 1500); // Give time for elements to render, since some of them are rendered with JS
            }
        });
    }, options);

    // Target the elements for observation
    const elementsToObserve = document.querySelectorAll('.underline-hand, .highlight-hand');
    elementsToObserve.forEach((el) => {
        observer.observe(el);
    });
});
